import type { Question } from '@/types/test';

const beginnerQuestions: Question[] = [
  {
    id: 1,
    category: 'Pattern Recognition',
    question: 'What comes next in the sequence? 2, 4, 6, 8, ?',
    options: ['9', '10', '12', '14'],
    correctAnswer: 1,
  },
  {
    id: 2,
    category: 'Logical Reasoning',
    question: 'If all roses are flowers and some flowers fade quickly, which statement must be true?',
    options: [
      'All roses fade quickly',
      'Some roses are not flowers',
      'Some roses might fade quickly',
      'No roses fade quickly',
    ],
    correctAnswer: 2,
  },
  {
    id: 3,
    category: 'Numerical',
    question: 'What is 15% of 200?',
    options: ['25', '30', '35', '40'],
    correctAnswer: 1,
  },
  {
    id: 4,
    category: 'Verbal',
    question: 'Which word does NOT belong with the others?',
    options: ['Apple', 'Orange', 'Banana', 'Potato'],
    correctAnswer: 3,
  },
  {
    id: 5,
    category: 'Pattern Recognition',
    question: 'Complete the pattern: △ ○ □ △ ○ ?',
    options: ['△', '○', '□', '◇'],
    correctAnswer: 2,
  },
  {
    id: 6,
    category: 'Logical Reasoning',
    question: 'If Monday is to Tuesday, then Thursday is to ?',
    options: ['Wednesday', 'Friday', 'Saturday', 'Sunday'],
    correctAnswer: 1,
  },
  {
    id: 7,
    category: 'Numerical',
    question: 'What is the next number? 1, 1, 2, 3, 5, 8, ?',
    options: ['11', '12', '13', '14'],
    correctAnswer: 2,
  },
  {
    id: 8,
    category: 'Spatial',
    question: 'How many sides does a hexagon have?',
    options: ['4', '5', '6', '7'],
    correctAnswer: 2,
  },
  {
    id: 9,
    category: 'Verbal',
    question: 'Choose the synonym for "Happy":',
    options: ['Sad', 'Joyful', 'Angry', 'Tired'],
    correctAnswer: 1,
  },
  {
    id: 10,
    category: 'Numerical',
    question: 'If a book costs $12 and you buy 3 books, how much do you spend?',
    options: ['$30', '$33', '$36', '$39'],
    correctAnswer: 2,
  },
];

const intermediateQuestions: Question[] = [
  {
    id: 1,
    category: 'Pattern Recognition',
    question: 'What number should replace the question mark? 3, 9, 27, 81, ?',
    options: ['162', '203', '243', '324'],
    correctAnswer: 2,
  },
  {
    id: 2,
    category: 'Logical Reasoning',
    question: 'All philosophers are thinkers. Some thinkers are writers. Which conclusion is valid?',
    options: [
      'All philosophers are writers',
      'Some philosophers might be writers',
      'No philosophers are writers',
      'All writers are philosophers',
    ],
    correctAnswer: 1,
  },
  {
    id: 3,
    category: 'Numerical',
    question: 'If x + 5 = 12, what is the value of 2x?',
    options: ['7', '10', '14', '24'],
    correctAnswer: 2,
  },
  {
    id: 4,
    category: 'Spatial',
    question: 'Which shape would be formed if you unfold a cube?',
    options: ['Cross pattern', 'Circle', 'Triangle', 'Hexagon'],
    correctAnswer: 0,
  },
  {
    id: 5,
    category: 'Pattern Recognition',
    question: 'Complete: ACE, FHJ, KMO, ?',
    options: ['PRS', 'PRT', 'QSU', 'RTW'],
    correctAnswer: 1,
  },
  {
    id: 6,
    category: 'Numerical',
    question: 'A car travels 60 km in 1 hour. How far will it travel in 2.5 hours?',
    options: ['120 km', '130 km', '150 km', '180 km'],
    correctAnswer: 2,
  },
  {
    id: 7,
    category: 'Logical Reasoning',
    question: 'If it rains, the ground gets wet. The ground is wet. What can we conclude?',
    options: [
      'It rained',
      'It might have rained',
      'It did not rain',
      'It will rain',
    ],
    correctAnswer: 1,
  },
  {
    id: 8,
    category: 'Verbal',
    question: 'Analogy: Book is to Reading as Fork is to ?',
    options: ['Writing', 'Eating', 'Cooking', 'Cleaning'],
    correctAnswer: 1,
  },
  {
    id: 9,
    category: 'Numerical',
    question: 'What is 20% of 150 plus 10% of 200?',
    options: ['40', '45', '50', '55'],
    correctAnswer: 2,
  },
  {
    id: 10,
    category: 'Pattern Recognition',
    question: 'Find the odd one out: 2, 5, 10, 17, 26, 37, 49',
    options: ['2', '10', '26', '49'],
    correctAnswer: 3,
  },
  {
    id: 11,
    category: 'Spatial',
    question: 'How many squares are in a 3x3 grid?',
    options: ['9', '12', '14', '15'],
    correctAnswer: 2,
  },
  {
    id: 12,
    category: 'Logical Reasoning',
    question: 'Tom is taller than Jerry. Jerry is taller than Mike. Who is the shortest?',
    options: ['Tom', 'Jerry', 'Mike', 'Cannot determine'],
    correctAnswer: 2,
  },
  {
    id: 13,
    category: 'Numerical',
    question: 'If 5 workers can build a wall in 10 days, how many days will 10 workers take?',
    options: ['3 days', '5 days', '8 days', '15 days'],
    correctAnswer: 1,
  },
  {
    id: 14,
    category: 'Verbal',
    question: 'Which word is the antonym of "Abundant"?',
    options: ['Plentiful', 'Scarce', 'Rich', 'Multiple'],
    correctAnswer: 1,
  },
  {
    id: 15,
    category: 'Pattern Recognition',
    question: 'What comes next? 1, 4, 9, 16, 25, ?',
    options: ['30', '35', '36', '49'],
    correctAnswer: 2,
  },
];

const advancedQuestions: Question[] = [
  {
    id: 1,
    category: 'Abstract Reasoning',
    question: 'If all Bloops are Razzies and all Razzies are Lazzies, then all Bloops are definitely Lazzies?',
    options: ['True', 'False', 'Cannot determine', 'Sometimes true'],
    correctAnswer: 0,
  },
  {
    id: 2,
    category: 'Numerical',
    question: 'What is the value of x? 3x² - 12 = 0',
    options: ['±1', '±2', '±3', '±4'],
    correctAnswer: 1,
  },
  {
    id: 3,
    category: 'Pattern Recognition',
    question: 'Complete the series: 2, 6, 12, 20, 30, ?',
    options: ['38', '40', '42', '44'],
    correctAnswer: 2,
  },
  {
    id: 4,
    category: 'Logical Reasoning',
    question: 'In a certain code, COMPUTER is written as RFUVQNPC. How is SCIENCE written?',
    options: ['VDJFODF', 'UDJHOFH', 'TDJHQFH', 'SDJHOFG'],
    correctAnswer: 0,
  },
  {
    id: 5,
    category: 'Spatial',
    question: 'A cube is painted red on all faces, then cut into 27 smaller cubes. How many have exactly 2 red faces?',
    options: ['6', '8', '12', '16'],
    correctAnswer: 2,
  },
  {
    id: 6,
    category: 'Numerical',
    question: 'If (a+b)² = 49 and ab = 12, what is a² + b²?',
    options: ['13', '21', '25', '37'],
    correctAnswer: 2,
  },
  {
    id: 7,
    category: 'Abstract Reasoning',
    question: 'Which number doesn\'t fit the pattern? 1, 8, 27, 64, 125, 216, 340',
    options: ['8', '64', '216', '340'],
    correctAnswer: 3,
  },
  {
    id: 8,
    category: 'Verbal',
    question: 'Cryptic analogy: Ocean is to Desert as Fish is to ?',
    options: ['Bird', 'Camel', 'Sand', 'Water'],
    correctAnswer: 1,
  },
  {
    id: 9,
    category: 'Logical Reasoning',
    question: 'Five houses in a row are painted in different colors. The green house is to the left of the white house. The green house owner drinks coffee. Who drinks water?',
    options: ['Need more information', 'Green house owner', 'White house owner', 'Cannot solve'],
    correctAnswer: 0,
  },
  {
    id: 10,
    category: 'Numerical',
    question: 'A train travels 120 km at 60 km/h, then 180 km at 90 km/h. What is the average speed?',
    options: ['72 km/h', '75 km/h', '78 km/h', '80 km/h'],
    correctAnswer: 1,
  },
  {
    id: 11,
    category: 'Pattern Recognition',
    question: 'What is the next term? 1, 11, 21, 1211, 111221, ?',
    options: ['312211', '312213', '312311', '412211'],
    correctAnswer: 0,
  },
  {
    id: 12,
    category: 'Spatial',
    question: 'How many faces does a dodecahedron have?',
    options: ['8', '10', '12', '20'],
    correctAnswer: 2,
  },
  {
    id: 13,
    category: 'Abstract Reasoning',
    question: 'If 2=4, 3=9, 4=16, then 9=?',
    options: ['18', '36', '81', '162'],
    correctAnswer: 2,
  },
  {
    id: 14,
    category: 'Numerical',
    question: 'In a sequence: 1, 1, 2, 3, 5, 8, 13... What is the 12th number?',
    options: ['89', '133', '144', '233'],
    correctAnswer: 2,
  },
  {
    id: 15,
    category: 'Logical Reasoning',
    question: 'If statement "All A are B" is false, which must be true?',
    options: [
      'No A are B',
      'Some A are not B',
      'All B are A',
      'Some B are not A',
    ],
    correctAnswer: 1,
  },
  {
    id: 16,
    category: 'Verbal',
    question: 'Complete the analogy: Prelude:Performance :: Overture:?',
    options: ['Finale', 'Opera', 'Symphony', 'Rehearsal'],
    correctAnswer: 1,
  },
  {
    id: 17,
    category: 'Numerical',
    question: 'What is the sum of all prime numbers between 1 and 20?',
    options: ['75', '77', '79', '81'],
    correctAnswer: 1,
  },
  {
    id: 18,
    category: 'Pattern Recognition',
    question: 'Find the pattern: Z1, Y4, X9, W16, ?',
    options: ['V25', 'U25', 'V24', 'U24'],
    correctAnswer: 0,
  },
  {
    id: 19,
    category: 'Spatial',
    question: 'A rectangle is rotated 90° clockwise, then flipped horizontally. What is the net effect?',
    options: [
      'Same as original',
      '180° rotation',
      'Vertical flip only',
      'Different from all above',
    ],
    correctAnswer: 3,
  },
  {
    id: 20,
    category: 'Abstract Reasoning',
    question: 'If MENSA = 13-5-14-19-1, what does GENIUS equal using the same pattern?',
    options: ['7-5-14-9-21-19', '7-5-14-9-20-19', '7-5-13-9-21-19', '6-5-14-9-21-19'],
    correctAnswer: 0,
  },
];

export const getQuestionsByLevel = (level: string): Question[] => {
  switch (level) {
    case 'beginner':
      return beginnerQuestions;
    case 'intermediate':
      return intermediateQuestions;
    case 'advanced':
      return advancedQuestions;
    default:
      return beginnerQuestions;
  }
};
